import { useTranslation } from 'react-i18next';
const LoadingScreen = ({ message = 'Loading...', type = 'default' }) => {
  const { t } = useTranslation('components');
  return (
    <div className="relative min-h-screen bg-jc-bg flex flex-col items-center justify-center text-jc overflow-hidden">

      <div className="relative z-10 flex flex-col items-center justify-center w-full px-4">       
          <div className="w-full h-screen max-w-4xl ">
            <video 
              autoPlay 
              loop 
              muted 
              playsInline
              className="w-full h-auto rounded-lg shadow-2xl"
            >
              <source src='./Loder.mp4' type="video/mp4" /> {t('loader.videoUnsupported')}
            </video>
          </div>
      </div>
    </div>
  );
};

export default LoadingScreen;